import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import { showCaloriesFromFatSelector } from 'ordering/app/state/selectors';
import { usePdpContext } from '../pdp-provider';
import NutritionTable from './nutrition-table';
import messages from './messages';

const nutritionHeadingId = 'nutritionHeadingId';

export const Nutrition = ({ className, showCaloriesFromFat }) => {
  const {
    sizeInfo: { selectedSize },
  } = usePdpContext();
  const { nutrition } = selectedSize || {};
  return (
    <div className={`pb5 ${className || ''}`} data-e2e="nutritionSection">
      <Heading
        bottomBorder
        className="mb3 text-semibold"
        id={nutritionHeadingId}
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...messages.nutritionTitle} />
      </Heading>
      {nutrition ? (
        <NutritionTable
          nutrition={nutrition}
          nutritionHeadingId={nutritionHeadingId}
          showCaloriesFromFat={showCaloriesFromFat}
        />
      ) : (
        <FormattedMessage {...messages.nutritionNotAvailable} />
      )}
    </div>
  );
};

const select = (state) => ({
  showCaloriesFromFat: showCaloriesFromFatSelector(state),
});

export default connect(select)(Nutrition);
